module.exports = __webpack_public_path__ + "img/8.95b427c5.png";